const organizations = {
  addMember: 'Add a member',
  cannotDeleteLastOrganization: 'You cannot delete your last organization',
  createAnOrganization: 'Create an Organization',
  members: 'Members',
  myOrganization: 'My organization',
  noMembersToDisplay: 'No members to display',
  noOrganizationsToDisplay: 'No organizations to display',
  organizationDeleteFailed: 'Could not delete the organization',
  organizations: 'Organizations',
};

export default organizations;
